export const ApiTags = {
    Prompts: 'Prompts',
    Courses: 'Courses',
    Challenges: 'Challenges',
    Leaderboard: 'Leaderboard',
    Search: 'Search',
    Feed: 'Feed',
} as const;
